import { render, staticRenderFns } from "./TaskReminderPanel.vue?vue&type=template&id=9bb8be20&scoped=true"
import script from "./TaskReminderPanel.vue?vue&type=script&lang=js"
export * from "./TaskReminderPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskReminderPanel.vue?vue&type=style&index=0&id=9bb8be20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb8be20",
  null
  
)

export default component.exports